import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_LOGON: 'FETCH_TRANSFER',
  RESET: 'RESET',
}

const fetchReset = async state => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetchLogon = async (state, transfer) => {
  state = {
    ...state,
    isStatus: transfer.status,
    expireToken: sanitizeExpire({
      status: transfer.status,
      data: transfer.data,
      name: 'transferobj',
    }),
    data: sanitizeData({
      status: transfer.status,
      data: transfer.data,
      name: 'transferobj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TRANSFER:
      return fetchLogon(state, action.transfer)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const transfer = {
  init,
  actionTypes,
  reducer,
}

export default transfer
